export default {
  baseStyle: {
    marginBottom: 5
  },
  defaultProps: {
    colorScheme: 'black'
  }
}
